import React, { useEffect, useState } from "react";

// scss
import "shepherd.js/dist/css/shepherd.css";
import "flatpickr/dist/flatpickr.css";
import "choices.js/public/assets/styles/choices.min.css";
import "./assets/scss/hope-ui.scss";
import "./assets/scss/pro.scss";
import "./assets/scss/custom.scss";
import "./assets/scss/rtl.scss";
import "./assets/scss/customizer.scss";
import "./assets/custom/scss/custom.scss";
import "./assets/custom/css/styles.css";

// Redux
import { useDispatch } from "react-redux";
import { setSetting } from "./store/setting/actions";

function App({ children }) {
  const dispatch = useDispatch();
  const [maintenance, setMaintenance] = useState(null); // null: 로딩중, true: 점검, false: 정상

  useEffect(() => {
    dispatch(setSetting());

    fetch("https://medincurl-config.s3.ap-northeast-2.amazonaws.com/maintenance.json")
      .then(res => res.json())
      .then(data => setMaintenance(data.maintenance))
      .catch(() => setMaintenance(false)); // 실패 시 정상 상태로 간주
  }, [dispatch]);

  // 로딩 중일 때는 아무 것도 보여주지 않음
  if (maintenance === null) return null;

  // 점검 중일 경우 전용 메시지 표시
  if (maintenance === true) {
    return (
      <div style={{ height: "100vh" }} className="d-flex justify-content-center align-items-center flex-column">
        <h2 className="mb-2">시스템 점검 중입니다.</h2>
        <p>더 나은 서비스를 제공하기 위해 점검을 진행하고 있습니다. 잠시만 기다려 주세요.</p>
      </div>
    );
  }

  // 정상 상태일 경우만 실제 children 렌더링
  return <div className="App">{children}</div>;
}

export default App;
